var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downloadCard",staticStyle:{"text-align":"left"}},[_c('div',{staticStyle:{"width":"100%","text-align":"left"}},[_c('v-icon',[_vm._v(" mdi-cloud-download-outline ")]),_vm._v(" "+_vm._s(_vm.item[_vm.language].label)+" ")],1),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.item[_vm.language].body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }